import React, { memo, useMemo } from "react";
import { useTranslation } from "react-i18next";
import { colors, css } from "../../../Styles";
import { LOCATIONLIST, NumberDisplayList } from "../..";
import { Graph_QL, System } from "../../../Services";
import { NewProgressCicle } from "../../_Components/";
import { LocationListTypes } from "../../Animals/_Animals/locationContext";
import { Location } from "../../../Services/Agrisys_GqlDataCaller/LocationFeedingCalls/GQLCalls/getLfStructureCall";
import { Animal } from "../../../Services/Agrisys_GqlDataCaller/AnimalDataCalls/GQLCalls/getAnimalCall";

interface sectionModal_Props {
  onPenClick?: (penId: number) => void;
  animalsInSection: Animal[];
  pens: Location[];
  system: System;
  connect: {
    farm: string
    domain: string
    connection: Graph_QL.Connection
  }
  sectionId: number;
}
/**
 * SectionModal
 * @param activeSectionId The section number.
 * @param onPenSelected Function to handle the penId when a pen is clicked.
 * @returns A "div" to place in a modal to show all content from a Location Feeder Section.
 */
export default function SectionModal({ system, onPenClick, animalsInSection, pens, connect, sectionId }: sectionModal_Props) {
  const progressCircles = useMemo(() => {
    return (<div style={{ display: "flex" }}>
      <NewProgressCicle animals={animalsInSection} connect={connect} circleId={1} />
      <NewProgressCicle animals={animalsInSection} connect={connect} circleId={6} />
    </div>)
  }, [animalsInSection, connect]);

  return (<>
    <div style={{ ...css.modalTop }}>
      {progressCircles}
      <FeedCorrections animalsInSection={animalsInSection} />
    </div>
    <div style={{ ...css.seperatorLine }} />
    <LOCATIONLIST
      key={sectionId}
      listType={LocationListTypes.pens}
      headerPen={true}
      systemType={system.fk_system_types}
      pens={pens}
      onPenClick={(penId: number) => onPenClick ? onPenClick(penId) : undefined}
      connect={{ connection: connect.connection, farm: connect.farm, domain: connect.domain }}
    />
  </>)
}

const FeedCorrections = memo(({ animalsInSection }: { animalsInSection: Animal[] }) => {
  const { t } = useTranslation();
  const increasedPens = animalsInSection.filter((animal: Animal) => animal.correction && animal.correction > 0).length;
  const decreasedPens = animalsInSection.filter((animal: Animal) => animal.correction && animal.correction < 0).length;

  return (
    <div style={{ height: "170px", display: "flex", flexDirection: "column", alignItems: "center", justifyContent: "center", marginTop: "18px" }}>
      <NumberDisplayList
        units={[
          t("feed.feedCorrection.increased", { defaultValue: "Increased" }),
          t("feed.feedCorrection.decreased", { defaultValue: "Decreased" }),
          // t("feed.feedCorrection.disabled", { defaultValue: "Disabled" }),
        ]}
        values={[
          increasedPens,
          decreasedPens,
          // disabledPens
        ]}
        header={t("feed.feedCorrection.feedCorrections", { defaultValue: "Feed Corrections" })}
      />
    </div>
  )
});
